export enum MortgageType {
    Purchase = 1,
    Remortgage = 2,
    SecondCharge = 3,
}
